var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.5 62.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1{fill:#0F3549;}\r\n      .cls-2{fill:#FFD540;}\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Small"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 31.25,
    cy: 31.25,
    r: 31.25
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.7) translate(18, 12)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.49,30.33a1.5,1.5,0,0,0-1.5,1.5V57a1.69,1.69,0,0,1-1.69,1.69H5.2A1.69,1.69,0,0,1,3.51,57V21.17H19.38a1.5,1.5,0,0,0,1.5-1.5V3.81H41.3A1.69,1.69,0,0,1,43,5.5v5.62a1.5,1.5,0,0,0,3,0V5.5A4.69,4.69,0,0,0,41.3.81H19.38l-.28,0h0a1.49,1.49,0,0,0-.36.13l-.09,0a1.49,1.49,0,0,0-.32.23L.95,18.61a1.49,1.49,0,0,0-.23.32l0,.09a1.49,1.49,0,0,0-.13.36h0a1.5,1.5,0,0,0,0,.29V57A4.69,4.69,0,0,0,5.2,61.69H41.3A4.69,4.69,0,0,0,46,57V31.83A1.5,1.5,0,0,0,44.49,30.33ZM17.88,5.93V18.17H5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.93,7a5.28,5.28,0,0,0-7.46-.32l-9.78,9h0L22.17,34.52a1.48,1.48,0,0,0-.5.55L16.42,45a1.5,1.5,0,0,0,1.91,2.08l10.19-4.3a1.48,1.48,0,0,0,.6-.32l20.71-19h0l9.78-9A5.29,5.29,0,0,0,59.93,7ZM44.72,17.9h0l5.19-4.76L53,16.5,47.8,21.26h0l-19.6,18-3.08-3.36Zm-21.89,24-.89-1,1.38-2.61,2.23,2.43ZM57.58,12.29,55.2,14.47l-3.08-3.36L54.5,8.93a2.28,2.28,0,1,1,3.08,3.36Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.fecb13b930bf00e94620a190285173b4.svg";
export { ForwardRef as ReactComponent };